'use strict';

/**
 * Init All Widget Logic
 */
class TWER_WIDGETS_MARKER {

    /**
     * Widgets constructor
     *
     * @param props
     */
    constructor(props) {
        // Init JQuery
        this.$ = $ = props;

        // Init core constants/variables etc
        this.$widgets = $([
            '#treweler-widgets-tour-list',
        ].join(', '));

        const $widgets_area = document.querySelectorAll('.js-twer-widgets');

        // Init JQ UI sortable
        this.initSortable();

        // Add dynamic events for inner widget elements
        $widgets_area.forEach((element) => {

            element.addEventListener('click', event => {

                // Close/Open widget after click
                this.toggleWidget(event);

                // Click Add Widget button handler
                this.addWidget(event);

                // Click Remove Widget button handler
                this.removeWidget(event);

            });

            element.addEventListener('keyup', event => {
                // Change widget header after keyup handler on "value" input
                this.updateHeadWidget(event);
            });

        });

        this.triggerHelper();

    }

    /**
     * Init sortable method
     */
    initSortable() {
        this.$widgets.sortable({
            connectWith: '.js-twer-ui-repeater',
            handle: '.js-twer-widget-marker-ui-handle',
            cursor: 'move',
            receive: (event, ui) => this.updateAlienWidget(event, ui)
        }).disableSelection();
    }

    /**
     * Update widget head method
     *
     * @param event
     */
    updateHeadWidget(event) {
        const target = event.target;
        if (target.classList.contains('marker-picker')) {
            const $titleWidget = target.closest('.js-twer-widget-marker').getElementsByClassName('js-twer-title-widget')[0];


            if (target.options[target.selectedIndex].text) {
                $titleWidget.innerText = target.options[target.selectedIndex].text;
            } else {
                $titleWidget.innerHTML = '&nbsp;';
            }
        }
    }

    /**
     * Update alien widget after move from another list
     *
     * @param event
     * @param ui
     */
    updateAlienWidget(event, ui) {
        const $currentItem = ui.item[0];
        const $previousItem = ui.sender[0];
        const $repeater = $currentItem.parentNode;

        const currentPosition = $repeater.dataset.position;
        const previousPosition = $previousItem.dataset.position;
        const newIndex = $repeater.childElementCount.toString();

        let currentItemHtml = $currentItem.innerHTML;

        const regex_name = new RegExp(`${previousPosition}`, 'mg');
        const regex_id = new RegExp(`${previousPosition.replace('_', '-')}`, 'mg');

        currentItemHtml = currentItemHtml.replace(regex_name, currentPosition);
        currentItemHtml = currentItemHtml.replace(regex_id, currentPosition.replace('_', '-'));
        currentItemHtml = currentItemHtml.replace(/\]\[\d+\]\[/gm, `][${newIndex}][`);
        currentItemHtml = currentItemHtml.replace(/-\d+-/gm, `-${newIndex}-`);

        $currentItem.innerHTML = currentItemHtml;

        this.updateSortable();
    }

    /**
     * Update sortable elements after some actions
     */
    updateSortable() {
        this.$widgets.sortable('refresh');
        this.$widgets.sortable('refreshPositions');
        this.triggerHelper();
    }

    /**
     * Remove widget method
     *
     * @param event
     */
    removeWidget(event) {
        if (event.target.classList.contains('js-twer-remove-widget')) {
            event.preventDefault();
            event.target.closest('.js-twer-widget-marker').remove();

            this.updateSortable();
        }
    }

    /**
     * Toggle widget method
     *
     * @param event
     */
    toggleWidget(event) {
        const $widgetHandle = event.target.closest('.js-twer-widget-marker-handle');
        if (!!$widgetHandle) {
            event.preventDefault();
            $widgetHandle.closest('.js-twer-widget-marker').classList.toggle('open');
        }
    }

    /**
     * Add widget method
     *
     * @param event
     */
    addWidget(event) {
        if (event.target.classList.contains('js-twer-add-widget-marker')) {
            event.preventDefault();
            const $widget = event.target.closest('.widget-marker-container');
            const $template = $widget.getElementsByClassName('js-twer-repeater-template')[0];
            const $repeater = $widget.getElementsByClassName('js-twer-repeater')[0];
            const range = document.createRange();

            let selectedMarker = $widget.getElementsByClassName('tour-marker-picker')[0];

            // check if select value are valid id
            if (parseInt(selectedMarker.value) <= 0) {
                return;
            }


            let templateHtml = $template.innerHTML;
            templateHtml = templateHtml.replace(/data-/mg, '');
            templateHtml = templateHtml.replace(/%index%/mg, $repeater.childElementCount.toString());
            templateHtml = templateHtml.replace(/%title%/mg, selectedMarker.options[selectedMarker.selectedIndex].text.toString());
            templateHtml = templateHtml.replace(/%idMarker%/mg, selectedMarker.value.toString());

            const documentFragment = range.createContextualFragment(templateHtml);
            $repeater.appendChild(documentFragment);
            event.target.blur();

            this.updateSortable();
        }
    }

    triggerHelper() {
        $('.js-zoom-range, .js-zoom-range-input').on('input', function () {
            let zoomCC = parseFloat($(this).val()).toFixed(2);
            if (zoomCC.trim() === '' || zoomCC.trim() === 'NaN' || zoomCC === 0.00 || zoomCC === 0.23) {
                zoomCC = 0;
            }

            if ($(this).data('id') === 'range-input') {
                $(this).closest('.js-twer-range').find('.js-zoom-range').val(zoomCC);
            } else {
                $(this).closest('.js-twer-range').find('.js-zoom-range-input').val(zoomCC);
            }
        });

        $('.twer-root').tooltip({
            selector: '.twer-help-tooltip'
        });


        $('.marker-picker').on('change', function () {
            let optionSelected = $("option:selected", this);
            let label = optionSelected.text();
            let pickerVal = parseInt(optionSelected.val());

            if (pickerVal > 0) {
                $(this).closest('.widget').find('.js-twer-title-widget').html(label);
            } else {
                $(this).closest('.widget').find('.js-twer-title-widget').html('&nbsp;');
            }
        });

        const $MainTourType = $('#treweler-tour-type');

        $('.js-adv-checkbox').on('change', function () {
            if ($(this).is(":checked")) {
                $(this).closest('.widget').find('.cogs').show();
                $(this).closest('.widget').find('.adv-settings').show();
                if ($MainTourType.val() !== 'fly') {
                    $(this).closest('.widget').find('.adv-fly').hide();
                }
            } else {
                $(this).closest('.widget').find('.cogs').hide();
                $(this).closest('.widget').find('.adv-settings').hide();
                if ($MainTourType.val() !== 'fly') {
                    $(this).closest('.widget').find('.adv-fly').hide();
                }
            }
        });


    }

}

export default TWER_WIDGETS_MARKER;
